import { IDealer, IRouteOneDealer } from 'modules/core/types/dealer';
import { IOption } from 'modules/core/types';
import { createSelector } from '@reduxjs/toolkit';
import { IResponseOptionData } from 'modules/CreditInterview/types';

import { RootState } from '../store';
import { IDealerReducerState } from '../reducers/dealer.reducer';

const getDealerState = (state: RootState): IDealerReducerState => state.dealer;

const getDealers = (state: RootState): IDealer[] => getDealerState(state).dealers;

export const getRouteOneDealers = (state: RootState): IRouteOneDealer[] => getDealerState(state).routeOneDealers;

export const getIsRouteOneDealersLoading = (state: RootState): boolean =>
  getDealerState(state).isRouteOneDealersLoading;

export const getDealerStores = (state: RootState): IOption[] => getDealerState(state).dealerStores;

export const getFormattedDealers = createSelector(getDealers, (dealers) =>
  dealers.map(
    ({ id, name }: IResponseOptionData): IOption => ({
      value: id,
      title: name,
    }),
  ),
);

export const getFormattedRouteOneDealers = createSelector(getRouteOneDealers, (routeOneDealers) =>
  routeOneDealers.map(
    ({ route_one_id, name }: IRouteOneDealer): IOption => ({
      value: route_one_id,
      title: name,
    }),
  ),
);
